export const PROJECT_TAGS = {
  ACCOUNT_ACCESS: 'account_access',
  CO_PARENT: 'co_parent',
  EDIT_INFO: 'edit_info',
  FINTECH: 'fintech',
  CHORES: 'chores',
  ONBOARDING: 'onboarding',
  PASSWORD: 'password',
  CHECKOUT: 'checkout',
  APP_ISSUES: 'app_issues',
  REFERRALS: 'referrals',
  PAYMENT_LINK: 'payment_link',
  SAVINGS: 'savings',
  SPLITS: 'splits',
  GROUPS: 'groups',
  TYPE_FORM: 'type_form',
} as const;
